

export enum HierarchyLoadStatus {
	SUCCESS, DEACTIVATED, DELETED, NO_ACCESS, ERROR, FORBIDDEN
}


